import { apiHelper } from '@/utils';
import { API } from '@/constants';

const API_URL = `${API.BASE_URL_API}/v1`;
const ENDPOINT = '/sport-club-sport-types';
export const sportClubSportTypeService = { getAll, show, store, update, updateStatus };

export function getAll(filter = {}) {
    const request = {
        params: {
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    if (filter?.isActive !== undefined && filter?.isActive !== null && filter?.isActive !== -1 && filter?.isActive !== '') {
        request.params.is_active = filter.isActive;
    }

    if (filter?.sortBy) request.params.sortBy = filter.sortBy;
    if (filter?.orderBy) request.params.orderBy = filter.orderBy;

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null && word !== '') {
            request.params[`search_words[${index}]`] = word;
        }
    });

    return apiHelper(API_URL).get(ENDPOINT, request);
}
export function show(uuid) {
    return apiHelper(API_URL).get(`${ENDPOINT}/${uuid}`);
}
export function store(data) {
    return apiHelper(API_URL).post(ENDPOINT, { name: data.name });
}
export function update(data) {
    return apiHelper(API_URL).put(`${ENDPOINT}/${data.uuid}`, { name: data.name });
}
export function updateStatus(data) {
    return apiHelper(API_URL).patch(`${ENDPOINT}/${data.uuid}`, { is_active: data.isActive });
}
